$( document ).ready(function() {



    let currentCajaId="";

    function muestraModal(texto) {
        const modal = document.getElementById("myModal");
        const span = document.getElementsByClassName("close")[0];
        const textomodal = document.getElementsByClassName("texto_modal")[0];
        textomodal.innerHTML = textomodal.getAttribute("data-".concat(texto));
        modal.style.display = "block";
        span.onclick = function cierraAlClicar() {
            modal.style.display = "none";
        };
        window.onclick = function cierraAlClicarWindows(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        };
    }


    function muestraModalCompartir(texto) {
        const modal = document.getElementById("myModalCompartir");
        const textomodal = document.getElementsByClassName("contenido_compartir")[0];
        textomodal.innerHTML = texto;
        modal.style.display = "block";
        $('.close').on('click',function(){
            modal.style.display = "none";
            muestraInfoCombinacion();
        });
        window.onclick = function cierraAlClicarWindows(event) {
            if (event.target === modal) {
                modal.style.display = "none";
                muestraInfoCombinacion();
            }
        };
    }

        $('.navegacion_prev').on('click',function(){
                $(".resumen_de_signos ul").slick("slickPrev");
        });

        $('.navegacion_next').on('click',function(){
                $(".resumen_de_signos ul").slick("slickNext");
        });

    $('.cajas_seleccion_signo .caja').on('click',function(){
        $('.overlay').fadeIn('slow');

        $('.otros_signos').show();
        if (!$('.resumen_de_signos ul').hasClass('slick-initialized')) {
            generaCarrusel();
        }

        currentCajaId=$(this).attr('id');
        $('.resumen_de_signos .slick-slide').on('click',function(){
            const signo=$(this).data('signo');
            const signonombre=$(this).data('signonombre');
            const signofecha=$(this).data('signofecha');
            $(`#${currentCajaId}`).html($(this).html());
            $(`#${currentCajaId}`).data('signo',signo);
            $(`#${currentCajaId}`).data('signonombre',signonombre);
            $(`#${currentCajaId}`).data('signofecha',signofecha);
            $('.otros_signos').slideUp('slow');
            $('.overlay').fadeOut('slow');
            if($('#caja_uno').data('signo')!=="" && $('#caja_dos').data('signo')!==""){
                $('.boton_combinacion').show('slow');
            }
        })

        $('.otros_signos .cerrar').on('click',function(){

            $('.otros_signos').slideUp('slow');
            $('.overlay').fadeOut('slow');
        });

    })
    function generaCarrusel(){
        $('.resumen_de_signos ul').slick({
            slidesToShow: 2,
            initialSlide:1,
            focusOnSelect: true,
            centerMode:true,
            adaptiveHeight:true,
            centerPadding:'50px',
            prevArrow: $('.navegacion_prev'),
            nextArrow: $('.navegacion_next'),
        });

    }

    function muestraInfoCombinacion(){
        const signo1 = $('#caja_uno').data('signo');
        const signo1Titulo = $('#caja_uno').data('signonombre');
        const signo1Fecha = $('#caja_uno').data('signofecha');
        const signo2 = $('#caja_dos').data('signo');
        const signo2Titulo = $('#caja_dos').data('signonombre');
        const signo2Fecha = $('#caja_dos').data('signofecha');

        const lang = $('#idioma').val();
        $('.pregunta_grande .signo_uno img').attr('src',`./images/signos/${signo1}.png`);
        $('.pregunta_grande .signo_uno .titulo_signo').html(signo1Titulo);
        $('.pregunta_grande .signo_uno .fecha_signo').html(signo1Fecha);
        $('.pregunta_grande .signo_dos img').attr('src',`./images/signos/${signo2}.png`);
        $('.pregunta_grande .signo_dos .titulo_signo').html(signo2Titulo);
        $('.pregunta_grande .signo_dos .fecha_signo').html(signo2Fecha);
        const url = "consulta_signo.php";
        $.ajax({
            method: "POST",
            url,
            data: { signo1, signo2,lang }
        }).done(function (msg) {
            const datos=jQuery.parseJSON(msg);
            $('.titulo_final').html(datos.titulo);
            $('.descripcion_final').html(datos.descripcion);

            $('#pagina_uno').removeClass('active');
            $('#pagina_dos').addClass('active');

        });






    }
    function destruyeCarrusel(){
        if ($('.resumen_de_signos ul').hasClass('slick-initialized')) {
            $('.resumen_de_signos ul').slick('destroy');
            $('.resumen_de_signos ul').html('');
        }
    }


    function copyToClipboard(element) {
        const aux = document.createElement("input");
        aux.setAttribute("value", element);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        $('.copia_link').html(lang.enlace_copiado);
    }

    function saveAs(uri, filename) {
        const link = document.createElement('a');
        if (typeof link.download === 'string') {
            link.href = uri;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(uri);
        }
    }

    function capturaPantalla(){
        $('.atras').hide();
        $('.compartir').hide();
        $('.boton_combinacion').hide();

        html2canvas($("#pagina_dos")[0]).then((canvas) => {
                saveAs(canvas.toDataURL(), 'zodiac.png');
            });
        $('.atras').show();
        $('.compartir').show();
        $('.boton_combinacion').show();

    }

    $('#enviar').on('click',function(){

        modalFinal();
    })



    $('.atras').on('click',function(){
        $('#pagina_dos').removeClass('active');
        $('#pagina_uno').addClass('active');
    })
    $('.inicio').on('click',function(){
        const lang = $('#idioma').val();
        const url  = `https://weddingtools.net/zodiac/horoscopo.php?lang=${(lang)}&pais=${(lang)}`;
        // eslint-disable-next-line no-restricted-globals
        location.href=url;
    })

    function generalUrl(){
        const lang = $('#idioma').val();
        const signo1 = $('#caja_uno').data('signo');
        const signo2 = $('#caja_dos').data('signo');
        const url  = `https://weddingtools.net/zodiac/horoscopo.php?lang=${(lang)}&signo1=${(signo1)}&signo2=${(signo2)}&pais=${(lang)}`;
        return (url);
    }

    if($('#ejecutaAlIniciar').val()==='1'){
        $('.boton_combinacion').show();
        muestraInfoCombinacion();
    }

    $('.compartir').on('click',function(){
        const url=generalUrl();
        let texto='<div class="bloque_compartir">';
            texto+=`<div class="cabecera_compartir"><div class="icono_cabecera_compartir"><img src="images/compartir_popup.svg" class="img_fluid"></div>${lang.comparte_tu_resultado}</div>`;
            texto+='<div class="links_compartir">';
                texto+='<ul>';
                    texto+='<li class="whatsapp">';
                        texto+='<div class="icono_compartir"><img src="images/whats.svg" class="img_fluid"></div>';
                        texto+='<div  class="texto_compartir">';
                            texto+=`<a href="whatsapp://send?text=${lang.texto_whatsapp} ${encodeURIComponent(url)}">`;
                                texto+=lang.por_whatsapp;
                                texto+='</a>';
                            texto+='</div>';
                    texto+='</li>';
                    texto+='<li class="copy">';
                        texto+='<div class="icono_compartir"><img src="images/copy.svg" class="img_fluid"></div>';
                            texto+='<div  class="texto_compartir">';
                                texto+=`<a href="javascript:void(0);" class="copia_link">`;
                                    texto+=lang.copiar_enlace;
                                texto+='</a>';
                        texto+='</div>';
                    texto+='</li>';
                    texto+='<li class="download">';
                        texto+='<div class="icono_compartir"><img src="images/download.svg" class="img_fluid"></div>';
                        texto+='<div  class="texto_compartir">';
                            texto+=`<a href="javascript:void(0);" class="descarga_imagen">`;
                            texto+=lang.descargar_imagen;
                            texto+='</a>';
                        texto+='</div>';
                    texto+='</li>';
                texto+='</ul>';
            texto+='</div>';
        texto+='</div>';
        muestraModalCompartir(texto) ;

        $('.copia_link').on('click',function(){
            copyToClipboard(url);
        })

        $('.descarga_imagen').on('click',function(){
            capturaPantalla();
        })

    })

    function modalFinal(){
        const url=generalUrl();
        let texto='<div class="bloque_registrar">';
            texto+=`<img src="./images/${$('#idioma').val()}.png" class="logo_home img_fluid margen_centrado">`;
            texto+='<div class="logo_texto_popup">';
                texto+='<img src="./images/imagen_popup.svg" class="img_regalo img_fluid margen_centrado">';
            texto+='</div>';
            texto+='<div  class="texto_compartir">';
            texto+=lang.mensaje_popup;
            texto+='</div>';
            texto+='<div  class="boton_popup">';
                texto+=`<a href="${lang.me_apunto_url}" target="_blank"  >`;
                texto+=lang.me_apunto;
                texto+='</a>';
            texto+='</div>';

        texto+='</div>';


        muestraModalCompartir(texto) ;
    }

});
